console.log("🟢 staffelung.js IS RUNNING");

document.addEventListener("DOMContentLoaded", () => {
  const MIN = 3;
  const STEP = 3;

  /* ---------------------------------------
     NORMALIZE DISPLAY VALUES
  ---------------------------------------- */
  function normalizeDisplay(q) {
    q = parseInt(q) || MIN;
    if (q < MIN) q = MIN;
    return Math.ceil(q / STEP) * STEP;
  }

  /* ---------------------------------------
     ONLY CART NEEDS VERDOPPLUNG (×2)
  ---------------------------------------- */
  function cartQty(displayQty) {
    return displayQty * 2;
  }

  async function updateCartLine(lineIndex, displayQty) {
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        line: lineIndex,
        quantity: cartQty(displayQty)
      })
    });

    document.dispatchEvent(new Event("cart:updated"));
  }

  /* ---------------------------------------
     Remove Shopify listeners
  ---------------------------------------- */
  function resetButton(btn) {
    const clone = btn.cloneNode(true);
    btn.replaceWith(clone);
    return clone;
  }

  /* ---------------------------------------
     APPLY LOGIC ONLY FOR TAGGED PRODUCTS
  ---------------------------------------- */
  function initQuantity(input) {
    if (!input.dataset.verdopplung) return;

    const minus = resetButton(input.parentElement.querySelector('[name="minus"]'));
    const plus  = resetButton(input.parentElement.querySelector('[name="plus"]'));

    const isCart = Boolean(input.dataset.index);

    let display = isCart
      ? normalizeDisplay(parseInt(input.value) / 2)
      : normalizeDisplay(parseInt(input.value));

    input.value = display;

    /* PLUS */
    plus.addEventListener("click", () => {
      display += STEP;
      input.value = display;
      if (isCart) updateCartLine(input.dataset.index, display);
    });

    /* MINUS */
    minus.addEventListener("click", () => {
      display = Math.max(MIN, display - STEP);
      input.value = display;
      if (isCart) updateCartLine(input.dataset.index, display);
    });

    /* TYPING */
    input.addEventListener("change", () => {
      display = normalizeDisplay(input.value);
      input.value = display;
      if (isCart) updateCartLine(input.dataset.index, display);
    });
  }

  /* ---------------------------------------
     FORCE PRODUCT PAGE ALWAYS = 3
  ---------------------------------------- */
  function enforceMinOnProductPage() {
    document.querySelectorAll('input.quantity__input[data-verdopplung]:not([data-index])')
      .forEach(input => {
        if (parseInt(input.value) < MIN) input.value = MIN;
      });
  }

  /* ---------------------------------------
     INIT ALL INPUTS
  ---------------------------------------- */
  function initAll() {
    document.querySelectorAll("input.quantity__input").forEach(initQuantity);
    enforceMinOnProductPage();
  }

  initAll();

  /* ---------------------------------------
     After cart updates
  ---------------------------------------- */
  document.addEventListener("cart:updated", () => {
    setTimeout(initAll, 50);
  });

  /* ---------------------------------------
     Refresh theme reloads product section
  ---------------------------------------- */
  document.addEventListener("shopify:section:load", evt => {
    const id = evt.detail.sectionId || "";
    if (id.includes("product") || id.includes("main-product")) {
      setTimeout(initAll, 80);
    }
  });

  /* ---------------------------------------
     After Add to Cart → Reset to 3
  ---------------------------------------- */
  document.addEventListener("product:added", () => {
    setTimeout(() => {
      enforceMinOnProductPage();
      initAll();
    }, 80);
  });

  /* ----------------------------------------------------
   FINAL FIX → Reset Product Page Qty AFTER Add-to-Cart
---------------------------------------------------- */
function resetProductPageVerdopplung() {
  document.querySelectorAll(
    'input.quantity__input[data-verdopplung]:not([data-index])'
  ).forEach(input => {
    input.value = 3; // Always reset to 3
  });
}

/* ----------------------------------------------------
   LISTEN FOR REFRESH THEME CART DRAWER CLOSING
---------------------------------------------------- */
document.addEventListener('cart-drawer:close', () => {
  setTimeout(() => {
    resetProductPageVerdopplung();
  }, 50);
});

/* ----------------------------------------------------
   ALSO LISTEN FOR CART NOTIFICATION (POPUP ICON)
---------------------------------------------------- */
document.addEventListener('cart-notification:close', () => {
  setTimeout(() => {
    resetProductPageVerdopplung();
  }, 50);
});


/* ----------------------------------------------------
   UNIVERSAL FIX: Reset product page AFTER cart changes
---------------------------------------------------- */

let lastCartItemCount = null;

// Poll cart every 300ms → detect ADD TO CART
setInterval(async () => {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    const currentCount = cart.item_count;

    // First load → set baseline
    if (lastCartItemCount === null) {
      lastCartItemCount = currentCount;
      return;
    }

    // Detect increase (Add to Cart)
    if (currentCount > lastCartItemCount) {
      setTimeout(() => {
        // Reset Verdopplung fields on product page
        document.querySelectorAll(
          'input.quantity__input[data-verdopplung]:not([data-index])'
        ).forEach(input => {
          input.value = 3;
        });
      }, 120);
    }

    lastCartItemCount = currentCount;
  } catch (err) {
    console.warn("Cart watcher error:", err);
  }
}, 300);


});
